var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "sui-container",
    { staticClass: "login-form", attrs: { fluid: "" } },
    [_c("Header"), _c("LoginForm")],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }